const firebaseConfig = {
  apiKey: "AIzaSyBJJGolFrbaZKO70-4GJzEj3ghF7wWsELg",
  authDomain: "creative-agency-6bd46.firebaseapp.com",
  databaseURL: "https://creative-agency-6bd46.firebaseio.com",
  projectId: "creative-agency-6bd46",
  storageBucket: "creative-agency-6bd46.appspot.com",
  messagingSenderId: "682280548614",
  appId: "1:682280548614:web:6d0a29528cfda8eaaa8687"
};
export default firebaseConfig;